import React from "react";

import "./styles.scss";
import { currency } from "../../utils";

const ProductCard = (props) => {
  const {
    title = "Default",
    image,
    category = "Fatia",
    price = undefined,
    onClick = () => {},
  } = props;

  return (
    <div className="product-card adb-touchable" onClick={() => onClick(props)}>
      <div className="product-card__top">
        {price && (
          <div className="product-card__top__price">
            <b className="font-sans font-semibold text-green">
              {currency.format(price)}
            </b>
          </div>
        )}
        <img src={image} alt={title} loading="lazy" />
      </div>

      <div className="product-card__bottom">
        <span className="font-sans font-semibold text-peach">{title}</span>
        <b className="font-sans font-light text-mediumGray">{category}</b>
      </div>
    </div>
  );
};

export default ProductCard;
